export default class Application {
    constructor () {
        this.id = null
        this.name = ""
        this.client_id = null
        this.project_id = null
        this.cluster_id = null
        this.qa_cluster_id = null
        this.terraform_rds_password = null
        this.terraform_rds_username = null
        this.app_url = null
        this.api_url = null
        this.qa_env_file = ''
        this.production_env_file = ''
        this.git_url = ''
    }
}